import React from 'react';
import AliceCarousel from 'react-alice-carousel';

import "react-alice-carousel/lib/alice-carousel.css";
import './index.css';

class Cycle extends React.Component {
  state = {
    index: 0
  }
  text = [localStorage.getItem('lang') == 'ru'? 'Шаг 1':'Step 1',
          localStorage.getItem('lang') == 'ru'? 'Шаг 2':'Step 2',
          localStorage.getItem('lang') == 'ru'? 'Шаг 3':'Step 3',
          localStorage.getItem('lang') == 'ru'? 'Шаг 4':'Step 4',
          localStorage.getItem('lang') == 'ru'? 'Шаг 5':'Step 5',
          localStorage.getItem('lang') == 'ru'? 'Шаг 6':'Step 6',
          localStorage.getItem('lang') == 'ru'? 'Шаг 7':'Step 7',];
  
  items = [
    <div className="cycle__container">
      <div className="cycle__container__title">{localStorage.getItem('lang') == 'ru'? 'Шаг 1':'Step1'}</div>
      <h2 className="cycle__caption">{localStorage.getItem('lang') == 'ru'? 'Брифинг':'Briefing'}</h2>
      <p className="cycle__container__text">
      { localStorage.getItem('lang') == 'ru'? 'Для создания качественного проекта нам важно понимать как Вы его видите. Определяемся с целями и задачами, обсуждаем наполнение. Оцениваем целевую аудиторию и потенциальных клиентов. Детально изучаем приложения&nbsp;-&nbsp;аналоги, анализируем собранную информацию.':
      'To create a quality project it is important for us to understand how you see it. We are to define goals and objectives, discuss content. We evalute the target audience and potential clients. We study applications in detail - analogues, analyze the collected information'}
      </p>
    </div>,
    <div className="cycle__container">
      <div className="cycle__container__title">{localStorage.getItem('lang') == 'ru'? 'Шаг 2':'Step2'}</div>
      <h2 className="cycle__caption">{ localStorage.getItem('lang') == 'ru'? 'Прототипирование':'Prototype'}</h2>
      <p className="cycle__container__text">
      { localStorage.getItem('lang') == 'ru'? 'Прототип – это черновик решения задачи которую Вы перед нами поставили. Дизайнер рисует наброски, продумывает логику работы всего продукта.':
      'Prototype is a draft of the solution to the task you have set. The designer draws sketches, works out the logic of the whole product'}</p>
        <p className="cycle__container__text">
        { localStorage.getItem('lang') == 'ru'? 'По итогу получаем кликабельный прототип, который позволяет лучше воспринять будущий проект, еще раз проанализировать архитектуру и удобство в использовании.':
        'The result is a climatic prototype, which allows to better perceive the future project, to re-examine the architecture and usability.'}</p>
    </div>,
    <div className="cycle__container">
      <div className="cycle__container__title">{localStorage.getItem('lang') == 'ru'? 'Шаг 3':'Step 3'}</div>
      <h2 className="cycle__caption">{localStorage.getItem('lang') == 'ru'? 'Дизайн':'Design'}</h2>
      <p className="cycle__container__text">{localStorage.getItem('lang') == 'ru'? 'Концепция будущего дизайна уже видна в процессе прототипирования. Элегантно вписываем ваш фирменный стиль в проект, либо разработаем новый. Вносим в макеты штрихи и детали которые придают продукту изюминку.':
      'The concept of future design is already visible in the process of prototyping.'}</p>
      <p className="cycle__container__text">{localStorage.getItem('lang') == 'ru'? 'По завершению предложим лучшие идеи и решения.':
      'Elegantly we will either add your corporate style to the project or we will develop a new one. We introduce in the layouts the strokes and details which give the product a raisin. At the end we will oﬀer the best ideas and solutions.'}</p>
    </div>,
    <div className="cycle__container">
      <div className="cycle__container__title">{localStorage.getItem('lang') == 'ru'? 'Шаг 4':'Step 4'}</div>
      <h2 className="cycle__caption">{localStorage.getItem('lang') == 'ru'? 'Разработка':'Development'}</h2>
      <p className="cycle__container__text">{localStorage.getItem('lang') == 'ru'? 'В процессе разработки приложение оживает. Воплощаются все замыслы дизайнера, продукт из идеи превращается в рабочий инструмент, готовый выполнять поставленную задачу.':
      'Then the process of developing the application comes alive.'}</p>
      <p className="cycle__container__text">{localStorage.getItem('lang') == 'ru'? 'Обеспечим ему безопасность и быстродействие.':
      'All designer plans are implemented, the product is transformed from an idea into a working tool ready to perform the task. We’ll keep him safe and fast.'}</p>
    </div>,
    <div className="cycle__container">
      <div className="cycle__container__title">{localStorage.getItem('lang') == 'ru'? 'Шаг 5':'Step 5'}</div>
      <h2 className="cycle__caption">{localStorage.getItem('lang') == 'ru'? 'Тестирование':'Testing'}</h2>
      <p className="cycle__container__text">{localStorage.getItem('lang') == 'ru'? 'Тестируем удобство пользования и производительность.':'We test usability and performance.'}</p>
      <p className="cycle__container__text">{localStorage.getItem('lang') == 'ru'? 'Отрабатываем сценарии нагрузки и пользовательского поведения.Проводим все типы тестов, чтобы гарантировать, что ваш продукт совместим и правильно функционирует.':
      'We work on load scenarios and user behaviour. We perform all types of tests to ensure that your product is compatible and functioning correctly.'}</p>
    </div>,
    <div className="cycle__container">
      <div className="cycle__container__title">{localStorage.getItem('lang') == 'ru'? 'Шаг 6':'Step 6'}</div>
      <h2 className="cycle__caption">{localStorage.getItem('lang') == 'ru'? 'Запуск проекта':'Release'}</h2>
      <p className="cycle__container__text">
      {localStorage.getItem('lang') == 'ru'? 'Реализуем проект в срок и с требуемым качеством. В зависимости от задачи, готовый продукт размещается на веб - площадках или в закрытой локальной сети.':
      'We implement the project in time and with the required quality.'}</p>
      <p className="cycle__container__text">{localStorage.getItem('lang') == 'ru'? 'Передаем доступы и права.':
      'Depending on the task, the ﬁnished product is placed on the web-sites or at the closed local network. We transfer the access and rights to you.'}</p>
    </div>,
    <div className="cycle__container">
      <div className="cycle__container__title">{localStorage.getItem('lang') == 'ru'? 'Шаг 7':'Step 7'}</div>
      <h2 className="cycle__caption">{localStorage.getItem('lang') == 'ru'? 'Техническая поддержка и сопровождение':'Technical support and maintenance'}</h2>
      <p className="cycle__container__text">{localStorage.getItem('lang') == 'ru'? 'После запуска проекта мы предлагаем его дальнейшее техническое сопровождение.':
      'After launching the project we oﬀer its further technical follow-up.'}</p>
      <p className="cycle__container__text">{localStorage.getItem('lang') == 'ru'? 'Выпуск обновлений, развитие и добавление различных сервисов для совершенствования продукта.':
      'Release of updates, development and addition of various services for product improvement.'}</p>
    </div>,
  ];
  galleryItem = (item, i) => (
    <div key={`key-${i}`}><h2>{item}</h2></div>
  )

  thumbItem = (text, i) => (
    <li key={i} className={["cycle__steps", this.state.index === i ? "cycle__steps-active" : ""].join(" ")} onClick={() => this.Carousel._onDotClick(i)}>{text}</li>
  )

  onSlideChanged = (e) => this.setState({ index: e.item })

  render() {
    const items = this.items.map(this.galleryItem)
    return (
      <div className="for__cycle">
        <div className="cycle__for-mobile">
          <ul className="cycle__list">{this.text.map(this.thumbItem)}</ul>
        </div>
        <AliceCarousel
          onSlideChanged={this.onSlideChanged}
          items={items}
          startIndex={this.state.index}
          dotsDisabled={true}
          ref={el => this.Carousel = el}
          slideToIndex={this.state.index}
          responsive={this.responsive}
        />
      </div>
    );
  }
}
export default Cycle;



// WEBPACK FOOTER //
// ./src/components/cycle/index.jsx